import { createApp } from './vue';

import accordionSlots from './vue/apps/accordion-slots';

const accordionMountingContainer = document.querySelectorAll('.js-accordion-slots');

if (accordionMountingContainer) {
    const accordions = [];

    accordionMountingContainer.forEach((el) => {
        const app = createApp(accordionSlots).mount(el);
        accordions.push(app);
    });
}
